import type { FilterField } from '@/components/common/AdvancedFilter';
import { getDateFromToFilterFields } from '@/utils/filterFields';
import { toFilterOptions } from '@/utils/filters';
import { APPROVE_STATUS_OPTIONS } from '../constants/product.constants';
import type { BookEdition, BookType } from '../types/product.types';

const INSERTED_FROM_FILTER_KEY = 'insertedFrom';
const INSERTED_TO_FILTER_KEY = 'insertedTo';

export function getApproveStatusFilterField(): FilterField {
  return {
    key: 'approveTypeNo',
    label: 'Status',
    type: 'select',
    placeholder: 'Approved and pending',
    options: toFilterOptions(APPROVE_STATUS_OPTIONS),
  };
}

export function getPhoneFilterField(label: string): FilterField {
  return { key: 'receiverMobile', label, type: 'text', placeholder: '01XXXXXXXXX' };
}

export function getInstitutionNoFilterField(): FilterField {
  return { key: 'instituteCode', label: 'Institution No', type: 'number', placeholder: '4120' };
}

export function getInsertedDateFilterFields(): FilterField[] {
  return getDateFromToFilterFields({
    fromKey: INSERTED_FROM_FILTER_KEY,
    toKey: INSERTED_TO_FILTER_KEY,
    labelPrefix: 'Inserted',
  });
}

interface BookFilterOptions {
  bookTypes: BookType[] | undefined;
  editions: BookEdition[] | undefined;
}

export function getBookFilterFields({ bookTypes, editions }: BookFilterOptions): FilterField[] {
  const legacyBookTypes = (bookTypes ?? []).flatMap((bookType) =>
    bookType.legacyId === null ? [] : [{ id: bookType.legacyId, name: bookType.name }],
  );

  return [
    {
      key: 'bookTypeNo',
      label: 'Book Type',
      type: 'select',
      placeholder: 'All Book Types',
      options: toFilterOptions(legacyBookTypes),
      searchable: true,
    },
    {
      key: 'bookEditionId',
      label: 'Book Edition',
      type: 'select',
      placeholder: 'All Editions',
      options: toFilterOptions(editions),
      searchable: true,
    },
  ];
}
